// 存放所有通用接口

import axios from 'axios'
import jsonp from 'jsonp'
import { misApiHost } from '../config/env.conf'
const rimetBaseUrl = '/rimet/out/';
const clientName = 'lvyou_web';

export const logout = () => {
    return axios.get(`/rimet/out/auth/logout`, {
        params: {
            feclient: 'lvyou_web'
        }
    })
}

export const getUserInfo = () => {
    return axios.get(`/rimet/out/auth/user/menu`, {
        params: {
            feclient: 'lvyou_web',
            domainList: 'lvyou-ticket,open-jingjiu,open-gentuanyou,open-jijiu,open-frame,open-cheliang,open-wenchuang'
        }
    })
}

export const getMisUserInfo = () => {
    return new Promise((resolve, reject) => {
        jsonp(`${misApiHost}/tbms/api/getUserInfo/unops`, {
            prefix: 'callback'
        }, function(err, _data) {
            if (err) {
                console.log('登陆出错，请重试')
                reject(err)
            }
            const { data } = _data
            if (_data.status === 1 && !err) {
                reject({
                    status: 1,
                    message: '登录失败'
                })
            } else if (_data.ops === false) {
                console.log('====>login.error')
                reject(false)
            }
            resolve(data)
        })
    })
}

export const getAccountPermission = function(entrances) {
    return axios.get(`${rimetBaseUrl}auth/user/menu/grant`, {
        params: {
            feclient: clientName,
            entrances
        }
    });
}


// WEBPACK FOOTER //
// ./src/api/common.js